/** POC main content width — max-w-[1600px] mx-auto */
export const PAGE_CONTENT_CLASS =
  "w-full max-w-[1600px] mx-auto px-3 sm:px-4 lg:px-6 2xl:px-8";
